/* eslint-disable import/no-anonymous-default-export */

import { CircularProgress, List, ListItemButton, ListSubheader, ThemeProvider, createTheme } from '@mui/material';
import { React, useState, useEffect } from 'react';
import { PaginationNavigation } from '../../utils/funtions';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export default ({ userData, openModalHandler, isLoading }) => {
  const [
    tableData,
    setTableData,
  ] = useState(userData);

  const [
    currentPage,
    setCurrentPage,
  ] = useState(1);
  const itemsPerPage = 5;

  let indexOfLastItem = currentPage * itemsPerPage;
  let indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const [
    currentItems,
    setCurrentitems,
  ] = useState(userData.slice(indexOfFirstItem, indexOfLastItem));

  // Page change handlers
  const nextPage = () => {
    if (currentPage < Math.ceil(tableData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    setTableData(userData);
    console.log(userData);
    // Calculate the items for the current page
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentitems(userData.slice(indexOfFirstItem, indexOfLastItem));
  }, [userData]);

  useEffect(() => {
    // Calculate the items for the current page
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentitems(userData.slice(indexOfFirstItem, indexOfLastItem));
  }, [currentPage]);

  return (
    <>
      <div style={{ lineHeight: '2.2vw', border: 'none', borderRadius: '1.5vw', marginTop: '1.5vw' }}>
        {/* <table className="table table-hover table-dark" style={{ color: 'white', fontSize: '0.9vw', width: '100%', backgroundColor: 'transparent', margin: 0}}>
                    <thead style={{color: 'rgb(230, 230, 230)', borderBottom: '1px solid rgb(255, 255, 255, 0.1)', backgroundColor: 'rgb(255, 255, 255, 0.05)'}}>
                        <tr style={{}}>
                            <th style={{padding:'0.5w 1vw', paddingLeft:'1.5vw', width: '25%'}} scope="col">First Name</th>
                            <th style={{padding:'0.5w 1vw', width: '25%'}} scope="col">Last Name</th>
                            <th style={{padding:'0.5w 1vw', width: '50%'}} scope="col">Email Address</th>
                        </tr>
                    </thead>

                    <tbody style={{}}>
                        { !isLoading && !tableData.length &&
                        <tr>
                            <td colspan="7"><p style={{textAlign: 'center', marginTop: '20px', marginBottom: '20px'}}>No user found</p></td>
                        </tr>}
                        { isLoading &&
                        <tr>
                            <td colspan="7"><p style={{textAlign: 'center', marginTop: '20px', marginBottom: '20px'}}><CircularProgress color="inherit" /></p></td>
                        </tr>}
                        { currentItems.map( (user, index) =>
                            <tr key={index} style={{borderTop: '1px solid rgb(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => openModalHandler(user.id)}>
                                <td style={{padding:'0.5w 1vw', paddingLeft:'1.5vw'}} scope="row">{user.firstName}</td>
                                <td style={{padding:'0.5w 1vw'}}>{user.lastName}</td>
                                <td style={{padding:'0.5w 1vw'}}>{user.email}</td>
                            </tr>
                        )}
                    </tbody>
                </table> */}

        <ThemeProvider theme={darkTheme}>

          {/* table */}
          <div className="blur" style={{ lineHeight: '2vw', marginLeft: '0', marginRight: '0', borderRadius: '1.2vw', textAlign: 'left' }}>
            <List className="table table-hover table-dark" style={{ color: 'rgb(0, 15, 30, 0.5)', borderRadius: '1.2vw', fontSize: '0.75vw', backgroundColor: 'rgb(254, 254, 255, 0.8)', margin: 0, padding: 0, overflow: 'hidden' }}>
              <ListSubheader style={{ fontWeight: 600, fontSize: '0.8vw', lineHeight: '3vw', backgroundColor: 'rgb(0, 15, 30, 0.028)', color: 'rgb(0, 15, 30, 0.65)', padding: '0 2vw', display: 'flex', flexDirection: 'row' }}>
                {/* <div style={{display: 'flex', fontWeight: '600'}}> */}
                <div scope="col" style={{ padding: '0.1vw 1.5vw', flex: 1, lineHeight: '2.5vw' }}>FIRST NAME</div>
                <div scope="col" style={{ padding: '0.1vw 1.5vw', flex: 1, lineHeight: '2.5vw' }}>LAST NAME</div>
                {/* <th scope="col" style ={{padding:'0.5vw 1.5vw', width: '30%'}}>AS CLIENT NAME</th> */}
                <div scope="col" style={{ padding: '0.1vw 1.5vw', flex: 2, lineHeight: '2.5vw' }}>EMAIL ADDRESS</div>

                {/* </div> */}
              </ListSubheader>
              <div style={{ fontSize: '0.65vw', color: 'rgb(0, 15, 30, 0.8)' }}>
                {currentItems.map((user, index) => (
                  <ListItemButton id={`request-table-item-${user.id}`} key={index} style={{ cursor: 'pointer', lineHeight: '2vw', display: 'table-row', display: 'flex', flexDirection: 'row', borderTop: '1px solid rgb(0, 15, 30, 0.05)', fontSize: '0.85vw', padding: '0.5vw 2vw' }} onClick={() => openModalHandler(user.id)}>
                    {/* <ListItemButton style={{flex: 1}}> */}
                    <div style={{ padding: '0vw 1.5vw', flex: 1 }}>{user.firstName}</div>
                    {/* <td style ={{padding:'0.5vw 1.5vw'}}>{item.as_client_name}</td> */}
                    <div style={{ padding: '0vw 1.5vw', flex: 1 }}>{user.lastName}</div>
                    <div style={{ padding: '0vw 1.5vw', flex: 2 }}>{user.email}</div>

                    {/* </ListItemButton> */}
                  </ListItemButton>
                ))}
                { !tableData.length && !isLoading
                  && (
                    <div style={{ display: 'flex' }}>
                      <div style={{ flex: 1 }}><p style={{ textAlign: 'center', fontSize: '0.85vw', color: 'rgb(0, 0, 0, 0.4)', marginTop: '2vw', marginBottom: '2vw' }}>No user found</p></div>
                    </div>
                  )}
                { isLoading
                  && (
                    <div style={{ display: 'flex' }}>
                      <div style={{ flex: 1 }}><p style={{ textAlign: 'center', marginTop: '2vw', marginBottom: '2vw' }}><CircularProgress color="inherit" /></p></div>
                    </div>
                  )}

              </div>
            </List>
          </div>
        </ThemeProvider>
      </div>

      <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1vw', marginRight: '0.5vw', marginLeft: '0.5vw', marginBottom: '0.5vw' }}>
        <div style={{ flex: 1, alignSelf: 'center' }}>
          <p style={{ color: 'rgb(0,15,30, 0.6)', fontSize: '0.85vw', marginLeft: '0.5vw', marginBottom: 0, textAlign: 'left' }}>
            Showing
            {indexOfFirstItem + 1}
            {' '}
            to
            {indexOfLastItem > tableData.length ? tableData.length : indexOfLastItem}
            {' '}
            of
            {tableData.length}
            {' '}
            entries
          </p>
        </div>

        {/* arrow buttons */}
        <PaginationNavigation onNextPage={nextPage} onPrevPage={prevPage} />

      </div>
    </>
  );
};
